import React from 'react';

interface IconProps {
    className?: string;
    size?: number;
    color?: string;
}

export const ActiveDeviceIcon: React.FC<IconProps> = ({className, size = 28, color = "#4CAF50"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="2" y="4" width="20" height="16" rx="3" stroke={color} strokeWidth="1.5" fill="none"/>
        <path d="M8 12 L11 15 L16 8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="18" cy="18" r="2" fill={color} stroke="none"/>
        <path d="M12 20 L12 4" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

export const PendingDeviceIcon: React.FC<IconProps> = ({
                                                           className,
                                                           size = 28,
                                                           color = "#FFC107",
                                                       }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {/* внешний круг */}
        <circle cx="12" cy="12" r="9" />

        {/* стрелки часов */}
        <path d="M12 7v5l3 2" />

        {/* optional: маленькая точка центра */}
        <circle cx="12" cy="12" r="1" fill={color} stroke="none" />
    </svg>
);

export const ExpiredDeviceIcon: React.FC<IconProps> = ({className, size = 28, color = "#F44336"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="2" y="4" width="20" height="16" rx="3" stroke={color} strokeWidth="1.5" fill="none"/>
        <path d="M8 8 L16 16 M16 8 L8 16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M12 20 L12 16" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

export const AddDeviceIcon: React.FC<IconProps> = ({className, size = 28, color = "#999999"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="2" y="4" width="20" height="16" rx="3" stroke={color} strokeWidth="1.5" fill="none"
              strokeDasharray="4 2"/>
        <path d="M12 8 L12 16 M8 12 L16 12" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

export const SettingsIcon: React.FC<IconProps> = ({
                                                      className,
                                                      size = 20,
                                                      color = "#ffffff",
                                                  }) => (
    <svg
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {/* центр */}
        <circle cx="12" cy="12" r="3"/>

        {/* шестерёнка */}
        <path
            d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.2a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.2a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h.1a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.2a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v.1a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.2a1.7 1.7 0 0 0-1.5 1z"/>
    </svg>
);

export const BackIcon: React.FC<IconProps> = ({className, size = 24, color = "#ffffff"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path d="M15 18L9 12L15 6" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

export const StatsIcon: React.FC<IconProps> = ({className, size = 20, color = "#3cffb3"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <rect x="3" y="10" width="4" height="11" fill={color} opacity="0.8" rx="1"/>
        <rect x="10" y="6" width="4" height="15" fill={color} opacity="0.8" rx="1"/>
        <rect x="17" y="2" width="4" height="19" fill={color} opacity="0.8" rx="1"/>
    </svg>
);

export const ProtocolIcon: React.FC<IconProps> = ({className, size = 12, color = "#4CAF50"}) => (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" fill="none"/>
        <path d="M12 8 L12 12 L14 14" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);